var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"id":"editor","value":_vm.value,"useCustomImageHandler":""},on:{"input":_vm.update,"image-added":_vm.handleImageAdded}})}
var staticRenderFns = []

export { render, staticRenderFns }